// Generated from SVG to Code Figma Plugin

export const BaseLineClear = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M3 12C3 7.02991 7.02991 3 12 3C16.9701 3 21 7.02991 21 12C21 16.9701 16.9701 21 12 21C7.02991 21 3 16.9701 3 12ZM15.0305 13.8183C15.3652 14.153 15.3652 14.6957 15.0305 15.0305C14.6957 15.3652 14.153 15.3652 13.8183 15.0305L12.0263 13.2385L10.1817 15.0831C9.84699 15.4178 9.30428 15.4178 8.96954 15.0831C8.63481 14.7484 8.63481 14.2057 8.96954 13.8709L10.8141 12.0263L8.96954 10.1817C8.63481 9.84699 8.63481 9.30428 8.96954 8.96954C9.30428 8.63481 9.84699 8.63481 10.1817 8.96954L12.0263 10.8141L13.8183 9.02219C14.153 8.68746 14.6957 8.68746 15.0305 9.02219C15.3652 9.35693 15.3652 9.89964 15.0305 10.2344L13.2385 12.0263L15.0305 13.8183Z"
      fill="#E0E0E0"
      fillRule="evenodd"
    />
  </svg>
);
